export default function initDropdown() {
    const $dropdownContainers = document.querySelectorAll('.js-dropdown-container');
    $dropdownContainers.forEach($container => {
        new DropDown($container);
    });
}

/**
 * Make elements collapsibles
 *
 * Usage:
 * <div
 *   class="js-dropdown-container"
 * >
 *   <button class="js-dropdown-button">Toggle menu</button>
 *   <ul class="js-dropdown-content">
 *     <li>Menu item</li>
 *   </ul>
 * </div>
 */
class DropDown {
    constructor($container) {
        this.$container = $container;
        this.$button = $container.querySelector('.js-dropdown-button');
        this.$content = $container.querySelector('.js-dropdown-content');

        this.init();
    }

    /**
     * Initialize the dropdown elements
     *
     * @return {void}
     */
    init() {
        this.$container.addEventListener('click', (evt) => {
            if (!this.$container.classList.contains('open') && evt.target === this.$button) {
                this.openDropdown();
            } else if (evt.target.closest('.js-dropdown-content') !== this.$content) {
                this.closeDropdown();
            }
        });

        // ferme le dropdown quand on clique à l'exterieur
        document.addEventListener('click', (evt) => {
            if (this.$container.classList.contains('filter') && this.$container.classList.contains('open') && evt.target.closest('.js-dropdown-button') !== this.$button && evt.target.closest('.js-dropdown-content') !== this.$content) {
                this.closeDropdown();
            }
        }); 
        
        // ferme le dropdown à la sélection d'un radio
        this.$container.querySelectorAll('input').forEach((item) => {
            item.addEventListener('click', (evt) => {
                this.closeDropdown();
            });
        })
    }

    /**
     * Ouvre le dropdown
     *
     * @return {void}
     */
    openDropdown() {
        this.$container.classList.add('open');
    }

    /**
     * Ferme le dropdown
     *
     * @return {void}
     */
    closeDropdown() {
        this.$container.classList.remove('open');
    }
}
